import { render, staticRenderFns } from "./DriverUnitsReact.vue?vue&type=template&id=3bf17fe5&"
import script from "./DriverUnitsReact.vue?vue&type=script&lang=js&"
export * from "./DriverUnitsReact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports